export default __webpack_public_path__ + "static/media/access-portal.5614e18b.svg";